<template>
  <div class="expandable-settings-item" :class="classes">
    <!-- Item's head, title and icons -->
    <div class="v-centerer expandable-settings-item__title" @click="itemExpand()">
      <Icon :rotate-left="!content.expanded">
        {{ arrowDownLine }}
      </Icon>
      <EditableLabel :value="title" :disabled="true" />
      <slot name="right" />
    </div>

    <!-- Expandable content -->
    <TransitionExpand>
      <div v-if="content.expanded" class="sd-overflow sd-overflow--auto-height" :class="overflowClass">
        <slot />
      </div>
    </TransitionExpand>
  </div>
</template>

<script>
/**
 * Expandable items with slot
 *
 * @vue-prop {String} title - Title of the item
 * @vue-prop {String} htmlId - HTML id. If set, the opened/closed state will be saved
 * @vue-prop {Array} parentIds - If set, tries to update parents height when expanding
 * @vue-prop {String} overflowClass - Class to apply to the overflow div
 * @vue-prop {Boolean} defaultExpand - True if this should be expanded by default
 * @vue-prop {Boolean} forgetState - If not set, keep a default 'open' satte in the store
 * @vue-prop {Boolean} noAnimation - Prevent animating expansion
 * @vue-prop {Boolean} refreshOnResize - True if the content should be updated when the window is resized
 */

import EditableLabel from '@/components/editable-label.vue';
import Icon from '@/components/icon.vue';
import TransitionExpand from '@/components/transition-expand.vue';
import { EXPAND_SETTINGS_ITEM } from '@/store/mutation-types';
import { wideArrowRightMedium, arrowDownLine } from '@/assets/icons';

export default {

  name: 'ExpandableSettingsItem',

  components: {
    EditableLabel,
    Icon,
    TransitionExpand,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    overflowClass: {
      type: String,
      default: '',
    },
    defaultExpand: Boolean,
    forgetState: Boolean,
    noAnimation: Boolean,
    refreshOnResize: Boolean,
  },

  data() {
    return {
      arrowDownLine,
      wideArrowRightMedium,
      content: {
        expanded: false,
        id: this.htmlId,
      },
    };
  },

  computed: {
    classes() {
      return {
        // TODO Remove this class if not used
        expand: this.content.expanded,
        'expandable-settings-item--expanded': this.content.expanded,
      };
    },
  },

  mounted() {
    if ((this.htmlId && this.$store.state.expandedSettings[this.htmlId]) || this.defaultExpand) {
      this.itemExpand();
    }
    if (this.refreshOnResize) {
      $(window).on(`resizeEnd.${this.uuid}`, () => {
        this.itemExpand(true);
      });
    }
  },

  methods: {
    itemExpand(asRefresh) {
      if (asRefresh === true) {
        this.content.expanded = !this.content.expanded;
      }
      this.content.expanded = !this.content.expanded;
      this.$emit('update', this.content);
      this.$store.commit(EXPAND_SETTINGS_ITEM, this.content);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.expandable-settings-item {
  background: white;
  margin-bottom: $settings-items-margin;
  border-radius: $high-border-radius;

  &--expanded {
    .expandable-settings-item__title {
      border-bottom: 1px solid $color-gray-background;
    }
  }

  &__title {
    padding: 1rem;
    cursor: pointer;

    .icon {
      width: .9rem;
      height: .9rem;
      margin-right: 1rem;
      transition: transform 0.3s;
    }
  }
}
</style>
